import React from 'react';
import { useBranding } from 'context/BrandingContext';

// ==============================|| LOGO ||============================== //

// The image is configurable from Configuration > Setting.
const Logo = () => {
  const { logo } = useBranding();
  return <img height={50} src={logo} alt="Logo" />;
};

export default Logo;
